import { render } from "./PaletteViewComponent.vue?vue&type=template&id=4257158c"
import script from "./PaletteViewComponent.vue?vue&type=script&lang=js"
export * from "./PaletteViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/simon/workspace/tasman/3palette/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__